export default "__VITE_ASSET__BvtixyVL__"